export const StartParamsCodes = {
  DEBUG: "debug",
  REFERRER_ADDRESS: "ref",
  OPEN_APP: "app",
  OPEN_CATEGORY: "cat",
  OPEN_CATEGORY_WITH_SORT: "catsorted",
  OPEN_TOP: "top",
  OPEN_TOP_WITH_SORT: "topsorted",
  OPEN_FAVS: "favs",
  OPEN_DONATION: "open_donation",
  BUY_STARS_SUCCESS: "buy_stars_success",
  OPEN_ORDER: "order",

  TON_CONNECT: "tonconnect",
} as const;
